"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapiGetAuthTokenResponseToJSON = exports.CapiGetAuthTokenResponseFromJSONTyped = exports.CapiGetAuthTokenResponseFromJSON = exports.instanceOfCapiGetAuthTokenResponse = void 0;
var runtime_1 = require("../runtime");
var CapiAuthTokenResponse_1 = require("./CapiAuthTokenResponse");
/**
 * Check if a given object implements the CapiGetAuthTokenResponse interface.
 */
function instanceOfCapiGetAuthTokenResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCapiGetAuthTokenResponse = instanceOfCapiGetAuthTokenResponse;
function CapiGetAuthTokenResponseFromJSON(json) {
    return CapiGetAuthTokenResponseFromJSONTyped(json, false);
}
exports.CapiGetAuthTokenResponseFromJSON = CapiGetAuthTokenResponseFromJSON;
function CapiGetAuthTokenResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : (json['data'].map(CapiAuthTokenResponse_1.CapiAuthTokenResponseFromJSON)),
    };
}
exports.CapiGetAuthTokenResponseFromJSONTyped = CapiGetAuthTokenResponseFromJSONTyped;
function CapiGetAuthTokenResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data === undefined ? undefined : (value.data.map(CapiAuthTokenResponse_1.CapiAuthTokenResponseToJSON)),
    };
}
exports.CapiGetAuthTokenResponseToJSON = CapiGetAuthTokenResponseToJSON;
